import { useCallback } from 'react';

import * as Types from './types';
import { useGenericSend } from '../useGenericSend';

export const useLeaderBoardSubscribeDetails = () => {
    const send = useGenericSend();

    return useCallback(async (options: Types.ILeaderBoardSubscribeDetailsRequestData) => {
        const response = await send<
            Types.ILeaderBoardSubscribeDetailsRequestData,
            Types.ILeaderBoardSubscribeDetailsResponseData
        >({
            ID: 71016,
            responses: [71017, 71018],
            description: 'Subscribe for leaderboard details notifications',
            ...options
        });

        return response;
    }, [send]);
};
